import React, { FC } from 'react';
import cls from 'classnames';
import { CheckIcon, XBoldIcon } from '@stashinvest/react-assets';

import { ValidationStringProps, ValidationStringVariant } from './ValidationString.types';
import { ColorClassnames } from '../../../../../tailwind/src/theme';

const variantColorMap: { [key: string]: ColorClassnames } = {
	[ValidationStringVariant.Default]: 'text-onSurfaceVariant',
	[ValidationStringVariant.Error]: 'text-error',
	[ValidationStringVariant.Success]: 'text-success',
};

const ValidationString: FC<ValidationStringProps> & {
	Variant: typeof ValidationStringVariant;
} = (props) => {
	const { variant, children } = props;
	const color = variantColorMap[variant || ValidationStringVariant.Default];
	const IconComponent = variant === ValidationStringVariant.Error ? XBoldIcon : CheckIcon;
	return (
		<div className={cls('validation-string', props.variant, props.className)}>
			<IconComponent size="2XS" color={color} />
			<p>{children}</p>
		</div>
	);
};

ValidationString.displayName = 'ValidationString';
ValidationString.Variant = ValidationStringVariant;

export default ValidationString;
